import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';
import { Nullable } from 'shared_DEPRECATED/types';

import {
  ScheduledMessage,
  ScheduledMessagesListResponse,
} from 'features/chat/config/types/ScheduledMessage';

export const useChatScheduledMessagesQuery = ({
  chatId,
}: {
  chatId: Nullable<string>;
}) => {
  const { request } = useQueryHTTPRequest();
  const queryClient = useQueryClient();

  const { data } = useQuery<
    ScheduledMessagesListResponse,
    any,
    ScheduledMessage[]
  >(
    [queryKeys.scheduledMessages, chatId],
    () => request({ url: `/api/chats/${chatId}/scheduled-messages` }),
    {
      initialData: {
        messages: [],
      },
      select: (data) => data.messages,
      refetchOnWindowFocus: false,
    }
  );

  const setNewScheduledMessages = useCallback(
    (onMessageSet: (messages: ScheduledMessage[]) => ScheduledMessage[]) => {
      queryClient.setQueryData<ScheduledMessagesListResponse>(
        [queryKeys.scheduledMessages, chatId],
        (oldMessages?: ScheduledMessagesListResponse) => {
          const newMessages = onMessageSet(oldMessages?.messages || []);

          return {
            messages: newMessages,
          };
        }
      );
    },
    [chatId, queryClient]
  );

  return {
    scheduledMessages: data as ScheduledMessage[],
    setNewScheduledMessages,
  };
};
